import { 
    ErrorsCallback,
    Success,
    LoadingClose
  } from "./alertService"
import Auth from "auth" 
import ConfigHost from "./ConfigHost"
import Axios from "axios" 
var Authorization = Auth.getUserToken()
export const APIGet = (
  URL,
  callBackSuccess,
  callBackError
) => { 
  
  var Request = Axios.create({
    baseURL: ConfigHost.HOST_API,
    // timeout: 60000,
    headers: {
      "Authorization": Authorization,
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
    }
  });
  Request.get(ConfigHost.HOST_API + URL)
  .then((response)=>{
    const responseData = response.data
    if(responseData.success){
      APIMiddlewareSuccess(responseData,callBackSuccess)
    }else{
      APIMiddlewareErrors(ConfigHost.HOST_API + URL, responseData, callBackError)
    } 
  })
  .catch((error) => {
    if(JSON.stringify(error) !== "{}")
    ErrorsCallback("API(GET) \n: " + (ConfigHost.HOST_API + URL) + " \n: "+error)
  }); 
}

export const APIPost = (
  URL,
  JsonDatas,
  callBackSuccess,
  callBackError
) => {
  var Request = Axios.create({
    baseURL: ConfigHost.HOST_API,
    // timeout: 60000,
    headers: {
      "Authorization": Authorization,
      // 'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
    },
    data:JsonDatas
  });
  Request.post(URL,{})
  .then((response)=>{  
    //Check API Response Status
    const responseData = response.data
    if(responseData.success){
      APIMiddlewareSuccess(responseData,callBackSuccess)
    }else{
      APIMiddlewareErrors(ConfigHost.HOST_API + URL, responseData, callBackError)
    } 
  })
  .catch((error) => { 
    if(JSON.stringify(error) !== "{}")
    ErrorsCallback("API(POST) \n: " + (ConfigHost.HOST_API + URL) + " \n: "+error)
  }); 
}

function APIMiddlewareSuccess(datas, callBackSuccess) { 
  if (datas.middlewareAlart) { 
    Success(datas.message)
  }
  if (callBackSuccess) {
    callBackSuccess(datas)
  }
}
function APIMiddlewareErrors(url, responseData, callBackError) {

  var middlewareAlart = responseData.middlewareAlart 
  if (middlewareAlart) {
    var errTxt = "" 
    if(responseData.status === 108){
      responseData.datas.forEach(element => {
        errTxt +=  " " + element
      });
    }  
    LoadingClose()
    ErrorsCallback(
      responseData.message + ((errTxt !== "")?" : ":"") + errTxt, 
      () => {
        const arr_status_logout = [101, 100, 99]
        if (arr_status_logout.indexOf(responseData.status) >= 0) {
          Auth.destroyAuthentication()
          window.location.reload() 
          return
        }
      }
    )
  }
  if (callBackError) {
    callBackError(responseData)
    return
  }
}
function APIMiddlewareErrorsSystems(url, responseData, error, callBackError) {
  if (responseData) {
    LoadingClose()
    ErrorsCallback(
      "Status is " + responseData.statusCode + " : " + responseData.statusMessage,
      null
    )
  } else {
    ErrorsCallback(
      url + " : " + error,
      null
    )
  }
  if (callBackError) {
    callBackError(responseData)
    return
  } 
}
